import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarImageIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-image"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#1B2536" rx={4} />
            <path
                className="decoration"
                stroke="#48505E"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M19.85 24.25h-8.496c-.556 0-.833 0-.962-.11a.46.46 0 0 1-.159-.384c.013-.169.21-.365.602-.758l7.795-7.794c.363-.363.544-.545.753-.613a.92.92 0 0 1 .567 0c.209.068.39.25.754.613l3.546 3.546v1.1m-4.4 4.4c1.54 0 2.31 0 2.898-.3a2.75 2.75 0 0 0 1.202-1.201c.3-.589.3-1.359.3-2.899m-4.4 4.4h-7.7c-1.54 0-2.31 0-2.898-.3a2.75 2.75 0 0 1-1.202-1.201c-.3-.589-.3-1.359-.3-2.899v-7.7c0-1.54 0-2.31.3-2.898A2.75 2.75 0 0 1 9.252 8.05c.589-.3 1.359-.3 2.898-.3h7.7c1.54 0 2.31 0 2.898.3a2.75 2.75 0 0 1 1.202 1.202c.3.589.3 1.359.3 2.898v7.7M14.625 12.792a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0Z"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarImageIcon);
export default Memo;
